export const theme = {
  colors: {
    greyDark: "#616161",
    greyDarker: "#444444",
    greyDarkest: "#262626",
    greyLight: "#F4F4F4",
    greyLighter: "#FAFAFA",
    greyPlaceholder: "#ADADAD",
    greyDisabled: "#C3C3C3",
    purple: "#9747FF",
    white: "#FFFFFF",
    red: "#E35353",
    background: "#F5F5F5",
    green: "#3DAE8B",
    greenDark: "#2B8267",
    yellow: "#FFEDBE",
    blue: "#B8C7D6",
    orange: "#D18400",
    graphColorBlue: "#6D7D8D",
    graphRing: "#EEF2F6",
    graphHighlightStart: "#81A6C8",
    graphHighlightEnd: "#97D1D9",
    tooltipBackground: "#3D3D3D",
    questionMarkBackground: "#FFFFFF",
    questionMarkForeground: "#616161",
    redDark: "#B64A4A",
    crayonGreen: "#99D9C5",
    crayonRed: "#EB7F7F",
    buttonLight: "#F7F7F7",
    disabledBar: "#E2EAF3",
  },
  borders: {
    smallRadius: "4px",
    buttonRadius: "5px",
    softRadius: "12px",
    largeRadius: "24px",
    smallWidth: "1px",
  },
  spacings: {
    tiny: "2px",
    small: "4px",
    medium: "0.5rem",
    large: "1rem",
    extreme: "2rem",
    larger: "3rem",
    huge: "6.5rem",
  },
  containers: {
    small: "900px",
    medium: "1200px",
    large: "1400px",
  },
  gradients: {
    blue: "linear-gradient(68deg, #81A6C8 0%, #97D1D9 100%)",
    red: "linear-gradient(68deg, #C67C66 0%, #EAAD81 100%)",
    yellow: "linear-gradient(68deg, #EABB90 0%, #F3EB73 100%)",
    green: "linear-gradient(68deg, #80B67D 0%, #AED37C 100%)",
    lightButton: "linear-gradient(180deg, #FFF 0%, #F5F5F5 100%)",
    darkButton: "linear-gradient(0deg, #616161 0%, #4F4F4F 100%)",
    greenBorder: "#80B67D",
    blueBorder: "#81a6c8",
    redBorder: "#C67C66",
    yellowBorder: "#EABB90",
  },
}

export type Theme = typeof theme

export const signalTheme: Theme = {
  ...theme,
  colors: {
    ...theme.colors,
    background: "#111111",
    greyLight: "#2B2B2B",
    greyLighter: "#111111",
    greyDisabled: "#686868",
    greyDark: "#BDBDBD",
    greyDarker: "#F2F2F2",
    white: "#202020",
    blue: "#4DB38A",
    graphColorBlue: "#4F806A",
    graphRing: "#484848",
    graphHighlightStart: "#267A5C",
    graphHighlightEnd: "#5CA982",
    tooltipBackground: "#242424",
    questionMarkBackground: "#E8E8E8",
    questionMarkForeground: "#202020",
    disabledBar: "#3A3A3A",
  },
  gradients: {
    ...theme.gradients,
    blue: "linear-gradient(68deg, #267A5C 0%, #5CA982 100%)",
    blueBorder: "#5CA982",
  },
}
